"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const store_1 = require("../../context/store");
const react_1 = require("react");
const MobileLayout = (props) => {
    const { children, style } = props;
    const [store] = (0, react_1.useContext)(store_1.Context);
    const { isMobile } = store;
    return isMobile ? ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'Kalend__MobileLayout', style: style }, { children: children }))) : null;
};
exports.default = MobileLayout;
